import backend, {CLIENT_SUPPORT_API} from 'utils/backend/server/api_library';

const getCaregiverFeedback = (clientRn, caregiverRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/caregiver_feedback/client/${clientRn}/caregiver/${caregiverRn}`;
  return backend.get(url);
};

export default {
  getCaregiverFeedback,
};
